import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Dropdown, Card ,Carousel, CardHeader} from "react-bootstrap";
import { AnchorComponent, ButtonComponent } from "../../components/elements";
import LabelTextareaComponent from "../../components/fields/LabelTextareaComponent";
import PageLayout from "../../layouts/PageLayout";
import specifics from "../../assets/data/specifics.json";
import reviews from "../../assets/data/reviews.json";
import Table from 'react-bootstrap/Table';
export default function FamilyReportPage() {
    const [family, SetFamily] = useState({});
    const { t } = useContext(TranslatorContext)

    const ratings = [
        { "count": "5 star", "graph": "90%", "user": "22" },
        { "count": "4 star", "graph": "75%", "user": "06" },
        { "count": "3 star", "graph": "30%", "user": "05" },
        { "count": "2 star", "graph": "15%", "user": "03" },
        { "count": "1 star", "graph": "5%", "user": "02" }
    ]

    return (
        <PageLayout>
            <div className="mc-card mb-4">
                <div className='mc-breadcrumb'>
                    <h3 className="mc-breadcrumb-title">{"Family Report"}</h3>
                    <ul className="mc-breadcrumb-list">
                        <li className="mc-breadcrumb-item"><Link to='/' className="mc-breadcrumb-link">{t('home')}</Link></li>

                        <li className="mc-breadcrumb-item">{"Family Report"}</li>
                    </ul>
                </div>
            </div>
            <div className="mc-card p-lg-4">
                <Row>
                    <Col xl={12}>
                        <h5 className="mc-divide-title mb-4"><small>{t('Data Entered By')}: {"Shakeel Tahir"}</small> </h5>
                    </Col>
                    <Col xl={5}>

                        <div className="mc-product-view-gallery">
                            <img src="/images/user.jpg" alt="product" />
                            <img src="/images/product/single/02.webp" alt="product" />
                            <img src="/images/product/single/03.webp" alt="product" />
                            <img src="/images/product/single/04.webp" alt="product" />
                            <img src="/images/product/single/05.webp" alt="product" />
                        </div>
                    </Col>
                    <Col xl={7}>

                        <div className="mc-product-view-info-group">
                            <h2 className="mc-product-view-info-title">FSF-12  | Shakeel Tahir</h2>
                            <div className="mc-product-view-meta">
                                <i className="material-icons">question_mark</i>
                                <h5>Status</h5>
                                <span>:</span>
                                <span className="badge badge-success">Drafted</span>
                            </div>
                            <div className="mc-product-view-meta">
                                <i className="material-icons">supervised_user_circle</i>
                                <h5>Gender</h5>
                                <span>:</span>
                                Male | 13 year's
                            </div>


                            <div className="mc-product-view-meta">
                                <i className="material-icons">diversity_1</i>
                                <h5>Martial Status</h5>
                                <span>:</span>
                                Male
                            </div>
                            <div className="mc-product-view-meta">
                                <i className="material-icons">not_listed_location</i>
                                <h5>Slavery Years</h5>
                                <span>:</span>
                                Male
                            </div>
                            <div className="mc-product-view-meta">
                                <i className="material-icons">credit_card</i>
                                <h5>CNIC</h5>
                                <span>:</span>
                                Male
                            </div>


                        </div>
                        <Row>
                            <Col md={6}>
                                <Card className="rounded">
                                    <img className="nic" src="/images/NIC.png" alt="logo" />
                                </Card>
                            </Col>
                            <Col md={6}>
                                <Card className="rounded">
                                    <img className="nic" src="/images/NIC.png" alt="logo" />
                                </Card>
                            </Col>
                        </Row>
                    </Col>


                    <Col xl={12}>
                        <h5 className="mc-divide-title mt-5 mb-4">{'FSF-12 | Shakeel Tahir More Details'}</h5>
                        <Row>

                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">drafts</i>
                                <h5>Draft Date</h5>
                                <span>:</span>
                                Male
                            </div></Col>

                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">calendar_month</i>
                                <h5>Entry Date</h5>
                                <span>:</span>
                                Male
                            </div></Col>

                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">settings_cell</i>
                                <h5>Cell:</h5>
                                <span>:</span>
                                Male
                            </div></Col>


                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">mosque</i>
                                <h5>Religion:</h5>
                                <span>:</span>
                                Male
                            </div></Col>

                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">credit_card</i>
                                <h5>Slavery Reason</h5>
                                <span>:</span>
                                Male
                            </div></Col>


                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">energy_savings_leaf</i>
                                <h5>Occupation</h5>
                                <span>:</span>
                                Male
                            </div></Col>





                            {/* cris */}

                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">blur_circular</i>
                                <h5>Abused</h5>
                                <span>:</span>
                                Male
                            </div></Col>
                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">flag</i>
                                <h5>Flagged</h5>
                                <span>:</span>
                                Male
                            </div></Col>

                            <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">water_drop</i>
                                <h5>Baptized</h5>
                                <span>:</span>
                                Male
                            </div></Col>
                        </Row>




                    </Col>

                    <h5 className="mc-divide-title mt-5 mb-4">{t('Address Details')}</h5>

                    <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                        <i className="material-icons">business</i>
                        <h5>Province</h5>
                        <span>:</span>
                        Male
                    </div></Col>


                    <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                        <i className="material-icons">cabin</i>
                        <h5>City</h5>
                        <span>:</span>
                        Male
                    </div></Col>


                    <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                        <i className="material-icons">castle</i>
                        <h5>Union Council</h5>
                        <span>:</span>
                        Male
                    </div></Col>


                    <Col md={6} className="mb-3">
                        <div className="mc-card address">
                            <div >
                                <h5>Present Address/Residense</h5>
                                <p>*Present residense will come here*</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} className="mb-3">
                        <div className="mc-card address">
                            <div >
                                <h5>Permanent Address</h5>
                                <p>*Present residense will come here*</p>
                            </div>
                        </div>
                    </Col>
                    <Col xl={12}>
                        <h5 className="mc-divide-title mt-5 mb-4">Family Details</h5>


                        <Row>
                            <Col md={4}>
                                <h6 className="mc-divide-title mb-4">   <i className="material-icons">girl</i> Spouse Information</h6>

                                <div className="mc-product-view-meta mb-2">
                                    <i className="material-icons">supervised_user_circle</i>
                                    <h5>Gender</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">girl</i>
                                    <h5>Name:</h5>
                                    <span>:</span>
                                    Male
                                </div>

                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">calendar_today</i>
                                    <h5>Age</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">calendar_view_month</i>
                                    <h5>Slavery Years</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">credit_card</i>
                                    <h5>CNIC</h5>
                                    <span>:</span>
                                    Male
                                </div>

                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">monitor_heart</i>
                                    <h5>Alive</h5>
                                    <span>:</span>
                                    Male
                                </div>


                            </Col>

                            <Col md={4}>
                                <h6 className="mc-divide-title mb-4"> <i className="material-icons">person_4</i> Father Information</h6>
                                <div className="mc-product-view-meta mb-2">
                                    <i className="material-icons">supervised_user_circle</i>
                                    <h5>Gender</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">boy</i>
                                    <h5>Name:</h5>
                                    <span>:</span>
                                    Male
                                </div>

                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">calendar_today</i>
                                    <h5>Age</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">calendar_view_month</i>
                                    <h5>Slavery Years</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">credit_card</i>
                                    <h5>CNIC</h5>
                                    <span>:</span>
                                    Male
                                </div>

                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">monitor_heart</i>
                                    <h5>Alive</h5>
                                    <span>:</span>
                                    Male
                                </div>

                            </Col>

                            <Col md={4}>
                                <h6 className="mc-divide-title mb-4"> <i className="material-icons">person_3</i> Mother Information</h6>
                                <div className="mc-product-view-meta mb-2">
                                    <i className="material-icons">supervised_user_circle</i>
                                    <h5>Gender</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">girl</i>
                                    <h5>Name:</h5>
                                    <span>:</span>
                                    Male
                                </div>

                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">calendar_today</i>
                                    <h5>Age</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">calendar_view_month</i>
                                    <h5>Slavery Years</h5>
                                    <span>:</span>
                                    Male
                                </div>
                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">credit_card</i>
                                    <h5>CNIC</h5>
                                    <span>:</span>
                                    Male
                                </div>

                                <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">monitor_heart</i>
                                    <h5>Alive</h5>
                                    <span>:</span>
                                    Male
                                </div>

                            </Col>
                        </Row>
                    </Col>
                    <Col xl={12} className="mt-5">
                        <h5 className="mc-divide-title mb-4">{"Children's Detail"}</h5>

                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Age</th>
                                    <th>CNIC</th>
                                    <th>Slavery Years</th>
                                    <th>School Going</th>

                                    <th>Training Refer</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Mark</td>
                                    <td>Otto</td>
                                    <td>Otto</td>
                                    <td>Otto</td>
                                    <td>@mdo</td>
                                    <td>@mdo</td>
                                </tr>

                            </tbody>
                        </Table>


                    </Col>
                    <Col xl={12} className="mt-5">
                        <h5 className="mc-divide-title mb-4">{"Kin's Detail"}</h5>

                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Relation</th>
                                    <th>Name</th>
                                    <th>Age</th>
                                    <th>CNIC</th>
                                    <th>Slavery Years</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Mark</td>
                                    <td>Otto</td>
                                    <td>Otto</td>
                                    <td>Otto</td>
                                    <td>@mdo</td>

                                </tr>

                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
             {/* IMAGE GALLERY */}
        <div className="mc-card">
        <h5 className="mc-divide-title mb-4">Image Gallery</h5>
          <Carousel
            style={{
              height: "300px",
            }}
          >
            <Carousel.Item>
              <img
                style={{ borderRadius: "10px" }}
                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQA2wMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAABAAIDBv/EABwQAQEBAAMBAQEAAAAAAAAAAAABESExQQISUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD1E+Wvxrf5QMyYvy0QYsUh+qoAwwrAQhQIEAF8mgFe2eWgCSQIqoEpUqCqC0CDwgFDTIOtUKgKrFwoDOLDUAIUAhIAcSBYy0rAZFawWAoqsXNA4okCkFhQMrDZiAL1ICsQB1RoAGKqcUBYGlgMldKAkUAS3FAXgrQoMxFUGSV2ATWDOQQpABEUAiKBBgB1SUAekXWpOACI9BWCGoD4EgZpiMgIUgAK1gsARqdsmA1QfACxn01UAsMALBmnlXQGHBq0HUFZyAKQJU0eACkC8DUQMemHhQB6LG6AYMVMBm9KFAkhgJJAgRaBFSoA6pP6OAdsBqmgIVCABQDViQHENOgKYDAVFPKBkWFAMWNYICBsWAAVgBmxtUBIPWhwCrLQwHYHFn8AYViBejDhkBlFWAyjEAq1EB6UrAZKw4ABxYCSQBEYCgw4gCKgAEYDtYpDapQGHFpBmxNAGWuwoCs4ZxsAMOKmAyVioBJAgRgBFYARwYCSxALFJhQAGwA7fSjVigMlYcAYlizkFkFawYAnZUi/ILEOj2CVGYYDNOK9qAKGqMBYDkWAEcQBmxoWApOEkCRxnAd4qkAhSAJICKkAKQD6ESA1lIDFUgSiQL0hAFEgHrXiQAFAAkD/2Q=="
                width="100%"
                height="300px"
              ></img>
            </Carousel.Item>

            <Carousel.Item>
              <img
                style={{ borderRadius: "10px" }}
                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQA2wMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAABAAIDBv/EABwQAQEBAAMBAQEAAAAAAAAAAAABESExQQISUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD1E+Wvxrf5QMyYvy0QYsUh+qoAwwrAQhQIEAF8mgFe2eWgCSQIqoEpUqCqC0CDwgFDTIOtUKgKrFwoDOLDUAIUAhIAcSBYy0rAZFawWAoqsXNA4okCkFhQMrDZiAL1ICsQB1RoAGKqcUBYGlgMldKAkUAS3FAXgrQoMxFUGSV2ATWDOQQpABEUAiKBBgB1SUAekXWpOACI9BWCGoD4EgZpiMgIUgAK1gsARqdsmA1QfACxn01UAsMALBmnlXQGHBq0HUFZyAKQJU0eACkC8DUQMemHhQB6LG6AYMVMBm9KFAkhgJJAgRaBFSoA6pP6OAdsBqmgIVCABQDViQHENOgKYDAVFPKBkWFAMWNYICBsWAAVgBmxtUBIPWhwCrLQwHYHFn8AYViBejDhkBlFWAyjEAq1EB6UrAZKw4ABxYCSQBEYCgw4gCKgAEYDtYpDapQGHFpBmxNAGWuwoCs4ZxsAMOKmAyVioBJAgRgBFYARwYCSxALFJhQAGwA7fSjVigMlYcAYlizkFkFawYAnZUi/ILEOj2CVGYYDNOK9qAKGqMBYDkWAEcQBmxoWApOEkCRxnAd4qkAhSAJICKkAKQD6ESA1lIDFUgSiQL0hAFEgHrXiQAFAAkD/2Q=="
                width="100%"
                height="300px"
              ></img>
            </Carousel.Item>

            <Carousel.Item>
              <img
                style={{ borderRadius: "10px" }}
                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQA2wMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAABAAIDBv/EABwQAQEBAAMBAQEAAAAAAAAAAAABESExQQISUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD1E+Wvxrf5QMyYvy0QYsUh+qoAwwrAQhQIEAF8mgFe2eWgCSQIqoEpUqCqC0CDwgFDTIOtUKgKrFwoDOLDUAIUAhIAcSBYy0rAZFawWAoqsXNA4okCkFhQMrDZiAL1ICsQB1RoAGKqcUBYGlgMldKAkUAS3FAXgrQoMxFUGSV2ATWDOQQpABEUAiKBBgB1SUAekXWpOACI9BWCGoD4EgZpiMgIUgAK1gsARqdsmA1QfACxn01UAsMALBmnlXQGHBq0HUFZyAKQJU0eACkC8DUQMemHhQB6LG6AYMVMBm9KFAkhgJJAgRaBFSoA6pP6OAdsBqmgIVCABQDViQHENOgKYDAVFPKBkWFAMWNYICBsWAAVgBmxtUBIPWhwCrLQwHYHFn8AYViBejDhkBlFWAyjEAq1EB6UrAZKw4ABxYCSQBEYCgw4gCKgAEYDtYpDapQGHFpBmxNAGWuwoCs4ZxsAMOKmAyVioBJAgRgBFYARwYCSxALFJhQAGwA7fSjVigMlYcAYlizkFkFawYAnZUi/ILEOj2CVGYYDNOK9qAKGqMBYDkWAEcQBmxoWApOEkCRxnAd4qkAhSAJICKkAKQD6ESA1lIDFUgSiQL0hAFEgHrXiQAFAAkD/2Q=="
                width="100%"
                height="300px"
              ></img>
            </Carousel.Item>
          </Carousel>
        </div>
            {/* Family Story */}
            <div className="mc-card p-lg-4">
                <Row>
                <Col xl={12} className="mt-5">
                        <h5 className="mc-divide-title mb-4">Family Story</h5>
                        <div className="mc-product-view-descrip">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae reprehenderit repellendus expedita esse cupiditate quos doloremque rerum, corrupti ab illum est nihil, voluptate ex dignissimos! Sit voluptatem delectus nam, molestiae, repellendus ab sint quo aliquam debitis amet natus doloremque laudantium? Repudiandae, consequuntur, officiis quidem quo deleniti, autem non laudantium sequi error molestiae ducimus accusamus facere velit consectetur vero dolore natus nihil temporibus aspernatur quia consequatur? Consequuntur voluptate deserunt repellat tenetur debitis molestiae doloribus dicta. In rem illum dolorem atque ratione voluptates asperiores maxime doloremque laudantium magni neque ad quae quos quidem, quaerat rerum ducimus blanditiis reiciendis</p>
                        </div>
                    </Col>
                </Row>
            </div>


             {/* Payment Details*/}
             <div className="mc-card p-lg-4">
                <Row>
                <Col xl={12} className="mt-5">
                        <h5 className="mc-divide-title mb-4">Payment Details</h5>
                        <Row>
                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">apartment</i>
                                    <h5>Brick Kiln</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>
                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">payments</i>
                                    <h5>Loan Type</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>
                          

                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">payment</i>
                                    <h5>Loan Amount</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>

                            <Col md={4}>
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">shopping_bag</i>
                                    <h5>Shop Khatta</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">medication</i>
                                    <h5>Medical Amount</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">food_bank</i>
                                    <h5>Food Ration</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">set_meal</i>
                                    <h5>Meal Amount</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>

                           
                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">newspaper</i>
                                    <h5>Utility Amount</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>
                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">bedroom_parent</i>
                                    <h5>Rent Amount</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">copy_all</i>
                                    <h5>Affidavit Amount</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>


                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">360</i>
                                    <h5>Other Amount</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                            <div className="mc-product-view-meta  mb-2">
                                    <i className="material-icons">bus_alert</i>
                                    <h5>Relation Amount</h5>
                                    <span>:</span>
                                    Male
                                </div>
                            </Col>
                            
                            <Col md={6}>
                                <Card className="" border="primary">
                                    <CardHeader className="bg-dark"><h6 className="text-light">Loan UnPaid Invoice</h6></CardHeader>
                               
                                    <img className="invoice" src="/images/NIC.png" alt="logo" />
                                   
                                </Card>
                            </Col>
                            <Col md={6}>
                                <Card className="" border="primary">
                                <CardHeader className="bg-dark"><h6 className="text-light">Khatta UnPaid Invoice</h6></CardHeader>

                                    <img className="invoice" src="/images/NIC.png" alt="logo" />
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </PageLayout>
    )
}